(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function initStickyProductAtc() {
    var wrapper = document.querySelector('[data-product-wrapper]');
    var bar = document.querySelector('[data-sticky-product-atc]');
    if (!wrapper || !bar) return;

    var mainAtc = wrapper.querySelector('[data-product-form-regular] [data-product-atc]')
      || wrapper.querySelector('[data-product-atc]');
    if (!mainAtc) return;

    var pricing = wrapper.querySelector('[data-product-pricing]');
    var variantSelection = wrapper.querySelector('variant-selection');
    var moneyFormat = bar.getAttribute('data-money-format') || (window.Shopify && window.Shopify.money_format);

    var trigger = bar.querySelector('[data-sticky-atc-trigger]');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    var compareEl = bar.querySelector('[data-sticky-atc-compare]');
    var badgeEl = bar.querySelector('[data-sticky-atc-badge]');
    var discountRowEl = bar.querySelector('.sticky-product-atc__discount-row');

    function setDiscountRowVisible(visible) {
      if (!discountRowEl) return;
      discountRowEl.classList.toggle('sticky-product-atc__discount-row--hidden', !visible);
    }
    var titleEl = bar.querySelector('[data-sticky-atc-title]');
    var imageEl = bar.querySelector('[data-sticky-atc-image]');
    var buttonTextEl = bar.querySelector('[data-sticky-atc-button-text]');
    var whatsappLink = bar.querySelector('[data-sticky-atc-whatsapp]');
    var defaultButtonLabel = buttonTextEl ? buttonTextEl.textContent.trim() : '';

    bar.removeAttribute('hidden');

    function setVisible(visible) {
      bar.setAttribute('data-sticky-animation-state', visible ? 'visible' : 'hidden');
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    var syncFromMainAtcPending = false;

    function scheduleSyncFromMainAtc() {
      if (syncFromMainAtcPending) return;
      syncFromMainAtcPending = true;
      requestAnimationFrame(function () {
        syncFromMainAtcPending = false;
        syncFromMainAtc();
      });
    }

    function syncFromMainAtc() {
      var mainText = mainAtc.querySelector('.atc-button--text');
      var isProcessing = mainAtc.classList.contains('processing');

      if (buttonTextEl && mainText) {
        var label = mainText.textContent.trim();
        if (label) {
          defaultButtonLabel = label;
          if (!isProcessing) {
            buttonTextEl.textContent = label;
          }
        } else if (defaultButtonLabel && !isProcessing) {
          buttonTextEl.textContent = defaultButtonLabel;
        }
      }

      trigger.classList.toggle('processing', isProcessing);
      trigger.disabled = mainAtc.disabled || isProcessing;
      trigger.classList.toggle('disabled', mainAtc.classList.contains('disabled') || mainAtc.disabled);
      trigger.setAttribute('aria-busy', isProcessing ? 'true' : 'false');
    }

    function getMainDiscountPercent() {
      if (!pricing) return null;

      var salesBadge = pricing.querySelector('[data-badge-sales]');
      if (salesBadge && window.getComputedStyle(salesBadge).display === 'none') {
        return null;
      }

      var percentEl = pricing.querySelector('[data-badge-sales] [data-price-percent-saved]');
      if (percentEl) {
        var percent = parseInt(percentEl.textContent.replace(/[^\d]/g, ''), 10);
        if (!isNaN(percent) && percent > 0) {
          return percent;
        }
      }

      return null;
    }

    function syncFromPricing() {
      if (!pricing) return;

      var currentMoney = pricing.querySelector('[data-price-container] [data-price]');
      var compareMoney = pricing.querySelector('[data-price-compare-container] [data-price-compare]');

      if (currentMoney && priceEl) {
        priceEl.textContent = currentMoney.textContent.trim();
      }

      var compareVisible = pricing.querySelector('[data-price-compare-container].visible');
      var hasCompare = compareMoney && compareVisible;

      if (compareEl && hasCompare) {
        compareEl.textContent = compareMoney.textContent.trim();
      }

      if (!badgeEl) {
        setDiscountRowVisible(hasCompare);
        return;
      }

      var percent = getMainDiscountPercent();
      if (percent === null && compareMoney && currentMoney && compareVisible) {
        var compareVal = parseFloat(compareMoney.textContent.replace(/[^\d.]/g, ''));
        var currentVal = parseFloat(currentMoney.textContent.replace(/[^\d.]/g, ''));
        if (compareVal > currentVal && compareVal > 0) {
          percent = Math.round((1 - currentVal / compareVal) * 100);
        }
      }

      if (percent !== null && percent > 0) {
        badgeEl.textContent = percent + '% OFF';
        setDiscountRowVisible(true);
      } else {
        setDiscountRowVisible(!!hasCompare);
      }
    }

    function syncTitle() {
      var pageTitle = wrapper.querySelector('[data-product-title]');
      if (titleEl && pageTitle) {
        titleEl.textContent = pageTitle.textContent.trim();
      }
    }

    function syncVariant(detail) {
      if (!detail || !detail.variant) return;

      var variant = detail.variant;

      if (priceEl && moneyFormat) {
        priceEl.textContent = formatMoney(variant.price, moneyFormat);
      }

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (compareEl && moneyFormat && onSale) {
        compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      }

      if (badgeEl) {
        var saved = null;
        if (onSale) {
          saved = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        }
        if (saved === null || saved <= 0) {
          saved = getMainDiscountPercent();
        }
        if (saved !== null && saved > 0) {
          badgeEl.textContent = saved + '% OFF';
          setDiscountRowVisible(true);
        } else {
          setDiscountRowVisible(!!onSale);
        }
      } else {
        setDiscountRowVisible(!!onSale);
      }

      if (imageEl && variant.featured_image) {
        var src = variant.featured_image.src || variant.featured_image;
        if (typeof src === 'string') {
          imageEl.src = src.indexOf('?') > -1 ? src.replace(/\?.*$/, '') + '?width=120' : src + '?width=120';
        }
      }

      syncFromMainAtc();
    }

    function buildWhatsappHref() {
      if (!whatsappLink) return;
      var base = whatsappLink.getAttribute('href');
      if (!base) return;

      var productUrl = window.location.href.split('#')[0];
      var title = titleEl ? titleEl.textContent.trim() : document.title;
      var message = encodeURIComponent('Hi, I have a question about ' + title + ' — ' + productUrl);

      if (base.indexOf('wa.me') > -1 || base.indexOf('whatsapp.com') > -1) {
        var separator = base.indexOf('?') > -1 ? '&' : '?';
        whatsappLink.setAttribute('href', base + separator + 'text=' + message);
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        setVisible(!entry.isIntersecting);
      },
      { root: null, rootMargin: '0px', threshold: 0 }
    );

    observer.observe(mainAtc);

    trigger.addEventListener('click', function () {
      if (mainAtc.disabled || trigger.classList.contains('processing')) return;

      trigger.classList.add('processing');
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');

      requestAnimationFrame(function () {
        var form = mainAtc.closest('form');
        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit(mainAtc);
        } else {
          mainAtc.click();
        }
      });

      window.setTimeout(function () {
        syncFromMainAtc();
      }, 500);
    });

    if (variantSelection) {
      variantSelection.addEventListener('variant-change', function (event) {
        requestAnimationFrame(function () {
          syncVariant(event.detail);
          syncFromPricing();
          syncTitle();
        });
      });
    }

    var atcObserver = new MutationObserver(function () {
      scheduleSyncFromMainAtc();
    });
    atcObserver.observe(mainAtc, {
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    document.addEventListener('cartcount:update', scheduleSyncFromMainAtc);
    document.addEventListener('closeFlyouts', scheduleSyncFromMainAtc);

    syncFromMainAtc();
    syncFromPricing();
    syncTitle();
    buildWhatsappHref();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyProductAtc);
  } else {
    initStickyProductAtc();
  }
})();
